var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { "widget-cards-buffer-wrapper": true, collapsed: _vm.collapsed },
    },
    [
      _c(
        "div",
        { staticClass: "widget-cards-buffer" },
        [
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.widgetItemsAny & _vm.collapsed,
                  expression: "widgetItemsAny & collapsed",
                },
              ],
              staticClass: "show-button",
              attrs: { fab: "", dark: "", color: "primary" },
              on: { click: _vm.fnShow },
            },
            [
              _c("v-icon", { attrs: { dark: "" } }, [
                _vm._v("\n                mdi-bell\n            "),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition-group",
            { attrs: { name: "slide", tag: "div" } },
            _vm._l(_vm.widgetItems, function (item, index) {
              return _c(
                "widget-card",
                { key: item.properties.dynamicId, staticClass: "wcard" },
                [
                  [
                    _c(
                      item.component,
                      _vm._b(
                        { tag: "component" },
                        "component",
                        item.properties,
                        false
                      )
                    ),
                  ],
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button-wrapper" },
        [
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.widgetItemsAny & !_vm.collapsed,
                  expression: "widgetItemsAny & !collapsed",
                },
              ],
              staticClass: "hide-button",
              attrs: { color: "secondary" },
              on: { click: _vm.fnHide },
            },
            [_vm._v(" > > > ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }